<section
  class="flex w-full flex-row items-center gap-8 rounded-lg border border-greyscale-50 bg-greyscale-50 p-4 transition-all duration-200"
>
  <div class="flex-1">
    <div class="mb-3 flex items-center justify-between">
      <h4 class="text-paragraph-s-med font-semibold text-greyscale-800">
        {{ "pack.tripLimit.title" | transloco }}
      </h4>
    </div>

    <!-- Progress Bar -->
    <div class="mb-3">
      <p-progressBar
        [value]="progressPercentage"
        [style]="{ height: '8px' }"
        [showValue]="false"
        [dt]="{ valueBackground: '{primary.300}', background: '{gray.200}' }"
      >
      </p-progressBar>
    </div>

    <!-- Compteur et statut -->
    <div class="flex items-center justify-between">
      <span class="text-paragraph-xs-reg text-greyscale-600">
        {{
          "discovery.progress.tripsUsed"
            | transloco
              : {
                  used: tripUsed,
                  limit: tripLimit,
                }
        }}
      </span>

      <span class="text-paragraph-xs-reg font-medium" [ngClass]="textColor">
        {{
          "discovery.progress.remaining"
            | transloco
              : {
                  count: tripLimit - tripUsed,
                }
        }}
      </span>
    </div>
  </div>
  <p-button
    [label]="'pack.tripLimit.purchaseMoreTrip' | transloco"
    (onClick)="openContactModal()"
    [outlined]="true"
  />
</section>
